export interface FeatureFlag {
    name: FeatureFlagName;
    enabled: boolean;
    createdBy: string;
    updatedBy: string;
    createdUtc: string;
    updatedUtc: string;
}

export enum FeatureFlagName {
    SENSORS = 'SENSORS',
    DIGITIZE = 'DIGITIZE',
    LOGGING_BEHAVIOR = 'LOGGING_BEHAVIOR',
    HECTARE = 'HECTARE',
    ADVANCED_ANALYTICS = 'ADVANCED_ANALYTICS',
    SURVEY_WORKSPACE_REPROCESS = 'SURVEY_WORKSPACE_REPROCESS',
    EASYPP_REPROCESSOR = 'EASYPP_REPROCESSOR',
    EASYPP_REDO_UNDO_FEATURE = 'EASYPP_REDO_UNDO_FEATURE'
}
